import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setInitMessage } from '../../actions/CommonAction';
import MatchingJobListComponent from './MatchingJobListComponent';
import MatchingAreaComponent from './MatchingAreaComponent';
import styles from './MatchingCompanyComponent.module.css';

class MatchingCompanyComponent extends Component {
  componentDidMount() {
    // Google Analytics
    window.gtagPageview();
  }

  componentWillUnmount() {
    const { setInitMessageAct } = this.props;
    setInitMessageAct();
  }

  render() {
    return (
      <div className={`${styles.matchingcompany}`}>
        <div className={`${styles.container}`}>
          <MatchingJobListComponent />
          <div className={`${styles.matchingAreacontainer}`}>
            <MatchingAreaComponent />
          </div>
        </div>
      </div>
    );
  }
}

export default connect(
  null,
  (dispatch) => ({
    setInitMessageAct: () => dispatch(setInitMessage()),
  }),
)(MatchingCompanyComponent);
